import { render } from "./AssignedUsersList.vue?vue&type=template&id=33dc2f5c&scoped=true"
import script from "./AssignedUsersList.vue?vue&type=script&lang=js"
export * from "./AssignedUsersList.vue?vue&type=script&lang=js"

import "./AssignedUsersList.vue?vue&type=style&index=0&id=33dc2f5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dc2f5c"]])

export default __exports__